export const ALL_TEAMS_ID = "0";
